package com.narbase.narnic.trial.utils.translations


/**
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2013] - [2018] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 12/14/17.
 */
object StorageManager {
    var language: Language = Language.En

}

enum class Language(
    val locale: String,
    val isRtl: Boolean,
    val appFontFamily: String
) {

    En("en-GB", isRtl = false, "'Work Sans', sans-serif"),
    Ar("ar-EG", isRtl = true, "'Cairo', 'Work Sans', sans-serif"),
    ;

}

